import { Component, OnInit } from '@angular/core';
import { AmbitService } from 'src/app/ambit.service';
import * as firebase from 'firebase';
import { Router } from '@angular/router';

@Component({
  selector: 'app-payout-requests',
  templateUrl: './payout-requests.component.html',
  styleUrls: ['./payout-requests.component.css']
})
export class PayoutRequestsComponent implements OnInit {

  public searchList: any = ['tripId', 'name'];
  public sortColumn:any = 'name';
  public sortType:boolean = false ;
  
  public filterStatus:any = 'All';
  public searchQuery:any ;
  constructor(public service: AmbitService,
  public router: Router ) {
    if(this.service.adminUser.userAccess.payments =='None') {
      this.router.navigate(['/home']);
    }
  }

  ngOnInit() {}

  toggleSortValue(val) {
    if(this.sortColumn==val){
      this.sortType = !this.sortType ;
    } else {
      this.sortColumn = val;
    }
  }

  onChangeStatus() {
    this.service.filteredTransactionList = [];
    if(this.filterStatus=='All') {
      this.service.filteredTransactionList = this.service.allTransactionList ;
    } else {
      for(var i=0; i<this.service.allTransactionList.length; i++ ) {
        if(this.filterStatus == this.service.allTransactionList[i].status || (this.filterStatus=='Pending' && !this.service.allTransactionList[i].status)) {
          this.service.filteredTransactionList.push(this.service.allTransactionList[i]);
        }
      }
    }
  }


  checkTripStatus(){
    var self=this;

    for (var i=0; i<self.service.allTransactionList.length; i++ ) {
      var transactionData = self.service.allTransactionList[i] ;
      if(transactionData.status !='Completed' || transactionData.status != 'Amount Reversed' ) {
        var data = self.service.allTrips.findIndex(x => x.tripID === transactionData.tripId);
        if(data && !data.status) {

        } else if (data && data.status=='Completed') {
          var updateData: any = {};
          updateData['Users/' + transactionData.uid + '/myCredits'] = transactionData.price + transactionData.myCredits;
          firebase.database().ref().update(updateData).then(() => {
            self.chnageTransactionStatus(transactionData.transactionID, data.status, i)
          }).catch((error) => {
            console.log(error) ;
          });
        } else if (data && data.status=='Cancelled') {
          self.chnageTransactionStatus(transactionData.transactionID, 'Amount Reversed', i)
        }
      }
    }
  }

  changePaymentStatus(transactionID, value) {
  
    var self = this;
    var updateData: any = {};
    var index = self.service.allTransactionList.findIndex(x => x.transactionID === transactionID);

    if (value == 'Declined') {
    //if (value == 'Cancelled') {
      updateData['Users/' + self.service.allTransactionList[index].uid + '/myCredits'] = self.service.allTransactionList[index].price + self.service.allTransactionList[index].myCredits;
      firebase.database().ref().update(updateData).then(() => {
        self.chnageTransactionStatus(transactionID, value, index)
      }).catch((error) => {

      });
    } else if (value == 'Completed') {
      self.chnageTransactionStatus(transactionID, value, index)
    }
  }

  chnageTransactionStatus(transactionID, value, index) {
    var self = this;
   var updateData:any = {};
    updateData['Transactions/' + transactionID + '/status'] = value;
    firebase.database().ref().update(updateData).then(() => {
      document.getElementById('paymentUpdateMd').click();
      self.service.allTransactionList[index].status = value;
     // self.filterStatus = 'All';
      self.searchQuery = '';
      self.service.filteredTransactionList = self.service.allTransactionList ;
    }).catch((error) => {
      console.log(error) ;
    });
  }

  }
